import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgSpeechBubbles = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21.33 7.34v5.33c-.07 2.76-2.49 5.17-6.67 5.33H9.33c0 1.19 0 0 0 0 .14 1.89 1.22 2.8 4 2.67H16c.54 2.09 3.89 2.77 6.66 2.66-1.92-1-2.75-1-2.66-2.66a3.8 3.8 0 0 0 4-3.61 2.5 2.5 0 0 0 0-.39V10a2.77 2.77 0 0 0-2.67-2.66M4 .67h10.66a3.67 3.67 0 0 1 4 3.31 2.7 2.7 0 0 1 0 .69v6.67a3.62 3.62 0 0 1-3.19 4 3.7 3.7 0 0 1-.81 0H8A8.25 8.25 0 0 1 2 18c2-1.07 1.91-1.2 2-2.61-2.56-.11-4.07-1.4-4-4V4.67c0-2.5 1.22-3.94 4-4"
    }));
export default SvgSpeechBubbles;
